'use es6';

import * as ObjectTypes from '../../objectTypes';
import { COMPANIES, CONTACTS, CONVERSATIONS, DEALS, ENGAGEMENTS, LINE_ITEMS, TICKETS } from 'reporting-data/constants/dataTypes/inboundDb';
import { getProperty } from 'reporting-data/properties/getProperty';
const OBJECT_TYPE_ID_TO_DATA_TYPE = {
  [ObjectTypes.CONTACT]: CONTACTS,
  [ObjectTypes.COMPANY]: COMPANIES,
  [ObjectTypes.DEAL]: DEALS,
  [ObjectTypes.ENGAGEMENT]: ENGAGEMENTS,
  [ObjectTypes.TICKET]: TICKETS,
  [ObjectTypes.LINE_ITEM]: LINE_ITEMS,
  [ObjectTypes.CONVERSATION]: CONVERSATIONS
};

/**
 * Temporary stopgap to borrow property metadata from reporting-data
 *
 * LabelAndDescription = { label: string, description: string }
 *
 * @returns {Promise<LabelAndDescription?>}
 */
export const fetchLegacyOptionLabelAndDescription = (objectTypeId, propertyName, id) => {
  const dataType = OBJECT_TYPE_ID_TO_DATA_TYPE[objectTypeId];
  return getProperty(dataType, propertyName).then(legacyProperty => {
    if (legacyProperty == null || legacyProperty.isEmpty()) {
      throw new Error(`No legacy property found for objectTypeId: ${objectTypeId} with propertyName ${propertyName}`, {
        cause: 'expected'
      });
    }
    return legacyProperty.get('options');
  }).then(options => {
    if (!options) {
      throw new Error('No `options` found in legacy property!', {
        cause: 'unexpected'
      });
    }
    return options.find(option => option.get('value') === id);
  }).then(foundOption => {
    if (!foundOption) {
      throw new Error('No `options` found in legacy property!', {
        cause: 'unexpected'
      });
    }
    return {
      label: foundOption.get('label'),
      description: foundOption.get('description')
    };
  }).catch(e => {
    if (e.cause === 'unexpected') {
      console.error(e);
    }
    return undefined;
  });
};